import React from "react";
import { Typography } from "@mui/material";

const ConflictsSummary = ({ totalConflicts }) => (
  <Typography variant="body1">
    Found <strong>{totalConflicts}</strong> potential conflict{totalConflicts !== 1 ? "s" : ""}.
  </Typography>
);

export default ConflictsSummary;
